<template>
  <div class="company-elem">
    <div
      v-if="show_name"
      class="company-name">{{ company_name }}</div>

      <div class="company-content">
      
        <div v-if="vendor() === 'wellfar' && company.vehicle_types?.length" class="company-info specs">
        <span class="specs-header">{{ $t('specialization')}}</span>
        <div>
          <i v-for="vt in vehicleTypes.filter(x => company.vehicle_types.includes(x.id))"
             class="svg-icon" :class="vt.icon_class"></i>
        </div>
      </div>

      <div class="company-info">
        <!-- <a class="company-address link-ext" :href="companyLink(company)"> -->
        <a class="company-address link-ext" @click.prevent="$emit('show-company-detail', company)">
          <i class="svg-icon location"></i>
          <span>{{ company.address }}</span>
        </a>
      </div>
      <div class="company-info">
        <template v-if="company.phone">
          <div class="company-phone" v-for="phone in splitPhones(company.phone)">
            <i class="svg-icon phone"></i>
            <a :href="'tel:' + phone">{{ phone | formatPhone}}</a>
          </div>
        </template>
        <div class="company-email" v-if="company.email">
          <i class="svg-icon email"></i>
          <a :href="'mailto:' + company.email">{{ company.email}}</a>
        </div>
        <div class="company-site" v-if="company.site_b2b">
          <i class="svg-icon site"></i>
          <a :href="company.site_b2b" target="_blank">{{ company.site_b2b }}</a>
        </div>
        <div class="company-site" v-if="company.site_b2c">
          <i class="svg-icon site"></i>
          <a :href="company.site_b2c" target="_blank">{{ company.site_b2c }}</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  props: ['company', 'vehicleTypes', 'show_name', 'dbConfig'],
  computed:{
    company_name(){
      return this.company.name.split(',')[0]
    },
  },
  methods:{
    // companyLink(company){
    //   // return `${this.$route.path}company/${company.id}/`;
    //   return `/where-to-buy/company/${company.id}/`;
    // },
    splitPhones(phones){
      return phones.split(';')
    },
    vendor(){
      return process.env.VENDOR
    },
  }
}
</script>
